export const exterior_view06ImageOptions = {
  angle: 'exterior_view06',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    SprayHood: 1,
    BiminiForHelmsman: 1,
    BiminiForForwardCockpit: 1,
    CockpitTent: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    LiftingArm: 1,
    Gangway: 1,
    SolarPanels: 1,
    WheelingSeats: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'SprayHood',
      dependency: 'TeakOnCoachroof'
    },
    {
      option: 'Wheel',
      dependency: 'AftBench'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: 'MastAndBoom'
    },
    {
      option: 'WheelingSeats',
      dependency: 'AftBench'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/exterior_view06.js